<ng-template #modal let-modal>
  <div class="modal-header">
    <h5 class="q-c-main q-bold">Edition du Cursus</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-modal p-0">
      <q-bodisplay class="w-100 h-100 mb-5" [item]="boModel" (sendEvent)="modal.dismiss()"></q-bodisplay>
    </div>
  </div>
</ng-template>
